import React, { Component } from 'react';
import Slider from 'react-slick';
import { Link } from 'react-router';
import WistiaVideoPlayer from '../../common/media/WistiaVideoPlayer';


class TakeTour extends Component {

	//let network = this.props.network;

	constructor() {
		super();
		//this.next = this.next.bind(this)
		//this.previous = this.previous.bind(this)
	}

	//next() {
	//	this.slider.slickNext()
	//}
	//previous() {
	//	this.slider.slickPrev()
	//}

    render() {

		const { params } = this.props;

        var settings = {
	        dots: false,
	        arrows: true,
	        infinite: false,
	        autoplay: false,
	        autoplaySpeed: 5000,
	        slidesToShow: 1,
	        slidesToScroll: 1,
	        swipeToSlide: false,
	        pauseOnHover: true,
        };

	   const url = "https://fast.wistia.com/embed/medias/m2a72cxo9x?videoFoam=true";

	    return (
	    	<div className="take-the-tour-body">
			    <div className="take-the-tour">
				    <div className="container height-100">
					    <div className="row height-100">
						    <div className="col-xs-12 height-100">
							    <div className="tutorial-body">
								    <Slider className="slider-take-the-tour" ref={ c => this.slider = c } { ...settings }>
									    <div key={ 1 } className="">
										    <div className="text-center">
											    <h5 className="h5 itn-brand-color">Welcome to the In Touch Networks tour!</h5>
										    </div>
										    <div className="row">
											    <div className="col-xs-12 col-md-8 col-md-offset-2">
												    <WistiaVideoPlayer url={ url }/>
											    </div>
										    </div>
									    </div>
									    <div key={ 2 } className="">
										    <div className="text-center">
											    <img src="/images/In-Touch-Networks-logo.png" alt="" className="itn-logo"/>
											    <p className="p-tag">As a member you have access to all In Touch Networks, which you can browse anytime using the bar above.</p>
										    </div>

										    <div className="row">
											    <div className="col-xs-12 col-md-6">
												    <p className="p-tag">Each Network gives you the opportunity to market your online CV to different audiences, apply for exclusive, off-market roles through unique jobs boards, hone your skills through bespoke learning and development courses and much, much more.</p>
												    <h4 className="h4"><span className="itn-brand-color">64%</span> of members regularly use multiple In Touch Networks to advance their careers.</h4>
											    </div>
											    <div className="col-xs-12 col-md-6">
												    <img src="/images/tour/tour-laptop-1.png" alt=""/>
											    </div>
										    </div>
									    </div>
									    <div key={ 3 } className="text-center">
										    <h5 className="h5 itn-brand-color">All the career tools you need in one place…</h5>
										    <p className="p-tag">You have access to all the tools you need to develop and sustain a successful career. Pick and choose the features you like or subscribe to everything in your account area by selecting one of our <b>Membership Packages</b>.</p>
										    <div className="row">
											    <div className="col-xs-12 col-md-6">
												    <div className="row">
													    <div className="col-xs-6">
														    <img src="/images/tour/tour-icon-1-job.png" alt="" className="icon"/>
														    <p className="p-tag">Find and apply for <span className="itn-brand-color">jobs</span> that aren’t advertised anywhere else</p>
													    </div>
													    <div className="col-xs-6">
														    <img src="/images/tour/tour-icon-1-networking.png" alt="" className="icon"/>
														    <p className="p-tag">Expand your contact list through <span className="itn-brand-color">networking</span> and getting involved</p>
													    </div>
												    </div>
												    <div className="row">
													    <div className="col-xs-6">
														    <img src="/images/tour/tour-icon-1-develop.png" alt="" className="icon"/>
														    <p className="p-tag"><span className="itn-brand-color">Develop</span> your professional skills with online training, webinars and podcasts</p>
													    </div>
													    <div className="col-xs-6">
														    <img src="/images/tour/tour-icon-1-information.png" alt="" className="icon"/>
														    <p className="p-tag">Find <span className="itn-brand-color">Information</span> on relevant industry knowledge or download helpful documentation</p>
													    </div>
												    </div>
											    </div>
											    <div className="col-xs-12 col-md-6">
												    <img src="/images/tour/tour-laptop-2.png" alt=""/>
											    </div>
										    </div>
									    </div>
									    <div key={ 4 } className="text-center">
										    <h5 className="h5 itn-brand-color">Market Your Online CV</h5>
										    <p className="p-tag">Our online CVs are at the heart of everything we do, giving you the platform to market yourself online and get noticed by the tens of thousands of actively recruiting companies that use our service.</p>
										    <div className="row">
											    <div className="col-xs-12 col-md-6">
												    <div className="row">
													    <div className="col-xs-6">
														    <img src="/images/tour/tour-icon-2-build.png" alt="" className="icon"/>
														    <p className="p-tag">Build your CV and post it live</p>
													    </div>
													    <div className="col-xs-6">
														    <img src="/images/tour/tour-icon-2-listing.png" alt="" className="icon"/>
														    <p className="p-tag">Expand your reach by listing your CV on multiple Networks</p>
													    </div>
												    </div>
												    <div className="row">
													    <div className="col-xs-6">
														    <img src="/images/tour/tour-icon-2-search.png" alt="" className="icon"/>
														    <p className="p-tag">Boost your chances of getting found by signing to appear in search results on BusinessTransformation.com</p>
													    </div>
												    </div>
											    </div>
											    <div className="col-xs-12 col-md-6">
												    <img src="/images/tour/tour-laptop-3.png" alt=""/>
											    </div>
										    </div>
										    <h4 className="h4">Members with complete profiles are <span className="itn-brand-color">8 times</span> more likely to find a job through the Networks.</h4>
									    </div>
									    <div key={ 5 } className="text-center">
										    <h5 className="h5 itn-brand-color">Apply For Exclusive Jobs</h5>
										    <div className="row">
											    <div className="col-xs-12 col-md-6">
												    <div className="row">
													    <div className="col-xs-6">
														    <img src="/images/tour/tour-icon-3-apply.png" alt="" className="icon"/>
														    <p className="p-tag">Search, apply and save roles from the jobs board</p>
													    </div>
													    <div className="col-xs-6">
														    <img src="/images/tour/tour-icon-3-preferences.png" alt="" className="icon"/>
														    <p className="p-tag">Tell us your job preferences – we’ll email relevant roles directly to you</p>
													    </div>
												    </div>
												    <div className="row">
													    <div className="col-xs-6">
														    <img src="/images/tour/tour-icon-3-recruitment.png" alt="" className="icon"/>
														    <p className="p-tag">Our in-house recruitment agency work tirelessly to find roles for you</p>
													    </div>
												    </div>
											    </div>
											    <div className="col-xs-12 col-md-6">
												    <img src="/images/tour/tour-laptop-4.png" alt=""/>
											    </div>
										    </div>
									    </div>
									    <div key={ 6 } className="text-center">
										    <h5 className="h5 itn-brand-color">Build Your Network</h5>
										    <p className="p-tag">In Touch Networks is a thriving community, made up of elite professionals. Members want to help each other succeed.  Connect with them online and at events, share knowledge and learn from your peers, and find experts to help with projects.</p>
										    <div className="row">
											    <div className="col-xs-12 col-md-6">
												    <div className="row">
													    <div className="col-xs-6">
														    <img src="/images/tour/tour-icon-4-search-member.png" alt="" className="icon"/>
														    <p className="p-tag">Search the member database and connect with your new network</p>
													    </div>
													    <div className="col-xs-6">
														    <img src="/images/tour/tour-icon-4-forum.png" alt="" className="icon"/>
														    <p className="p-tag">Join in forum conversations and start new discussions</p>
													    </div>
												    </div>
												    <div className="row">
													    <div className="col-xs-6">
														    <img src="/images/tour/tour-icon-4-events.png" alt="" className="icon"/>
														    <p className="p-tag">Browse events and reserve your place using our events calendar</p>
													    </div>
												    </div>
											    </div>
											    <div className="col-xs-12 col-md-6">
												    <img src="/images/tour/tour-laptop-5.png" alt=""/>
											    </div>
										    </div>
									    </div>
									    <div key={ 7 } className="text-center">
										    <h5 className="h5 itn-brand-color">Develop your skills
										    </h5>
										    <p className="p-tag">Identify areas for personal and professional improvement through our CPD-accredited career development programmes and courses, led by award-winning coaches and tailored specifically for your needs.</p>
										    <div className="row">
											    <div className="col-xs-12 col-md-6">
												    <div className="row">
													    <div className="col-xs-6">
														    <img src="/images/tour/tour-icon-5-ondemand.png" alt="" className="icon"/>
														    <p className="p-tag">Subscribe to on-demand training and earn CPD points at your own leisure</p>
													    </div>
													    <div className="col-xs-6">
														    <img src="/images/tour/tour-icon-5-webinars.png" alt="" className="icon"/>
														    <p className="p-tag">Sign up for interactive, tailor-made mentoring on webinars</p>
													    </div>
												    </div>
												    <div className="row">
													    <div className="col-xs-6">
														    <img src="/images/tour/tour-icon-5-podcasts.png" alt="" className="icon"/>
														    <p className="p-tag">Listen to our weekly podcasts for free</p>
													    </div>
												    </div>
											    </div>
											    <div className="col-xs-12 col-md-6">
												    <img src="/images/tour/tour-laptop-6.png" alt=""/>
											    </div>
										    </div>
									    </div>
									    <div key={ 8 } className="text-center">
										    <h5 className="h5 itn-brand-color">Information at your fingertips</h5>
										    <p className="p-tag">Keep up to date with the latest news in your sector. Looking for CV, contracts and other professional document templates? We have those too.</p>
										    <div className="row">
											    <div className="col-xs-12 col-md-6">
												    <div className="row">
													    <div className="col-xs-6">
														    <img src="/images/tour/tour-icon-6-documents.png" alt="" className="icon"/>
														    <p className="p-tag">Useful documents to help your business <br/></p>
													    </div>
													    <div className="col-xs-6">
														    <img src="/images/tour/tour-icon-6-updates.png" alt="" className="icon"/>
														    <p className="p-tag">Browse the latest news in your sector</p>
													    </div>
												    </div>
											    </div>
											    <div className="col-xs-12 col-md-6">
												    <img src="/images/tour/tour-laptop-7.png" alt=""/>
											    </div>
										    </div>
									    </div>
									    <div key={ 9 } className="text-center">
										    <h5 className="h5 itn-brand-color">Your In Touch Networks Toolbar</h5>
										    <p className="p-tag">For all your main account information</p>
										    <div className="row">
											    <div className="col-xs-12 col-md-6">
												    <div className="row">
													    <div className="col-xs-6">
														    <img src="/images/tour/tour-icon-7-message.png" alt="" className="icon"/>
														    <p className="p-tag">Search and contact any of our network members</p>
													    </div>
													    <div className="col-xs-6">
														    <img src="/images/tour/tour-icon-7-help.png" alt="" className="icon"/>
														    <p className="p-tag">Contact, ask, get help on everything to do with our websites</p>
													    </div>
												    </div>
												    <div className="row">
													    <div className="col-xs-6">
														    <img src="/images/tour/tour-icon-7-basket.png" alt="" className="icon"/>
														    <p className="p-tag">View your basket and purchase items</p>
													    </div>
													    <div className="col-xs-6">
														    <img src="/images/tour/tour-icon-7-settings.png" alt="" className="icon"/>
														    <p className="p-tag">Change settings and subscription settings</p>
													    </div>
												    </div>
											    </div>
											    <div className="col-xs-12 col-md-6">
												    <img src="/images/tour/tour-laptop-8.png" alt=""/>
											    </div>
										    </div>
									    </div>
								    </Slider>
								    <div className="skip-tutorial">
									    <Link to={ `/` } className="btn btn-primary btn-block">
										    <span className="label">Skip tutorial</span>
										    <span className="icon"><i className="fa fa-times fa-right"></i></span>
									    </Link>
								    </div>
								    {/*<button className='btn btn-primary tour-prev' onClick={this.previous}>Back</button>
								     <button className='btn btn-primary tour-next' onClick={this.next}>Next</button>*/}
								    {/*<ul className="buttons-right delete-modal-footer">
								     <li><button type="button" className="btn btn-close-tutorial" onClick ={ () => this.props.history.push ( `/${ network }`)}>close</button></li>
								     </ul>*/}
							    </div>
						    </div>
					    </div>
				    </div>
			    </div>
			    <div className="container">
				    <div className="row">
					    <div className="col-xs-12">
						    <ul className="buttons-center">
							    <li>
								    <Link className="btn btn-primary" to={ `/purchases` }>
									    <span className="label">Buy membership</span>
									    <span className="icon"><i className="fa fa-angle-right animated-right"/></span>
								    </Link>
							    </li>
						    </ul>
					    </div>
				    </div>
			    </div>
		    </div>

	    );
    }

}

export default TakeTour;



// WEBPACK FOOTER //
// src/client/components/site/pages/TakeTour.js